import { EnvironmentModuleEntryPoint } from '../../../manifest/environment-modules';

export interface ExtensionEntries {
    entryPoints: EnvironmentModuleEntryPoint[];
    conditionValidated: boolean;
}
